import { useTranslation } from 'react-i18next'

import { mapTaskToAssigneePickerStatus } from '../../../utils/utils'
import { OuterCard } from '../../components/outerCard/OuterCard'

import { useAuthState } from '@percent/partner-dashboard/common/hooks'
import { AssigneePicker, Button, Flex } from '@percent/lemonade'
import { TasksListProps } from './TaskList.types'
import styles from './TasksList.module.scss'

export function TasksList({ tasks, onSelectTask }: Readonly<TasksListProps>) {
  const { t } = useTranslation()
  const user = useAuthState()

  const assignee = { email: user?.user?.email ?? '', name: '', id: user?.user?.id ?? '' }

  return (
    <Flex direction="column" mt={16}>
      {tasks.map(task => {
        const { status, label } = mapTaskToAssigneePickerStatus(task, t)

        return (
          <OuterCard
            key={task.id}
            dataTestId={`task-${task.id}`}
            customBgColour="default"
            badgeContent={task.form?.displayName}
            badgeVariant="default"
          >
            <Flex className={styles.tasksListItem}>
              <AssigneePicker readonly assignee={assignee} status={status} statusLabel={label} />
              <Button
                variant="secondary"
                size="small"
                onClick={() => onSelectTask(task.form?.formId ?? '')}
                data-testid={`select-task-${task.id}-button`}
              >
                {t('grants.tasks.start')}
              </Button>
            </Flex>
          </OuterCard>
        )
      })}
    </Flex>
  )
}
